<template>
  <div>
    <section class="g-filterSearch uc-ml10">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="item"
        :class="item.status == query.status ? 'on' : ''"
        @click="
          query.status = item.status;
          loadData();
        "
      >
        {{ item.name }}
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入您想搜索的考试"
          class="uc-input"
          v-model="query.keyword"
          @keyup.enter="loadData"
        />
        <input
          type="submit"
          value="搜索"
          class="uc-btn blue"
          @click="loadData"
        />
      </div>
    </section>

    <section class="uc-examList uc-ml10">
      <!-- <div class="tags">
        <div class="tag">
          <div class="dot"></div>
          已通过
        </div>
        <div class="tag">
          <div class="dot red"></div>
          未通过
        </div>
      </div> -->
      <div class="content-empty" v-if="list.total_count == 0">
        <div class="emptyimg-box"></div>
        <p>暂无相关内容</p>
      </div>
      <div v-for="(item, index) in list.items" :key="index" class="item">
        <router-link to="" class="title" @click.native="handleExamClick(item)">
          <img
            src="../../assets/images/icon130.png"
            class="uc-icon20"
            v-if="item.exam_status == 0"
          />
          <img
            src="../../assets/images/icon131.png"
            class="uc-icon20"
            v-if="item.exam_status == 1 && item.is_pass == 0"
          />
          <img
            src="../../assets/images/icon132.png"
            class="uc-icon20"
            v-if="item.exam_status == 1 && item.is_pass == 1"
          />
          <img
            src="../../assets/images/icon133.png"
            class="uc-icon20"
            v-if="item.exam_status == 2"
          />
          <div class="c">{{ item.name }}</div>
          <span class="uc-font uc-next"></span>
        </router-link>
        <div class="con">
          <div class="sub-item">开始时间：{{ item.start_time }}</div>
          <div class="sub-item">结束时间：{{ item.end_time }}</div>
          <div class="sub-item">
            考试时长：{{ item.duration == 0 ? '不限' : item.duration + '分钟' }}
          </div>
          <div class="sub-item">试卷总分：{{ item.total_score }}分</div>
          <div class="sub-item">通过分数：{{ item.pass_score }}分</div>
          <div class="sub-item">
            可考次数：{{
              item.allow_times == 0 ? '不限' : item.allow_times + '次'
            }}
          </div>
          <div class="sub-item">
            出题方式：{{ item.question_way == 1 ? '随机' : '固定' }}
          </div>
          <div class="sub-item">
            评分方式：{{ (item.score_way = 1 ? '自动' : '手工') }}
          </div>
          <div class="sub-item">出卷人员：{{ item.create_first_name }}</div>
          <div class="sub-item">
            <i class="el-icon-set-up"></i>
            <span
              v-html="
                item.cert_tpl_id == 0
                  ? '无证书'
                  : item.certificate == null
                  ? '未获得证书'
                  : `<a href='${item.certificate.cert_url}' target=_blank>查看证书</a>`
              "
            >
            </span>
          </div>
        </div>
        <div class="operate" v-if="item.exam_status == 1 && item.config > 0">
          <router-link
            :to="{ name: 'ExamStatistics', params: { id: item.answer_id } }"
            target="_blank"
            class="uc-btn blue-plain"
            hover-class="none"
            v-if="(item.config & 2) == 2"
            >查看分数</router-link
          >
          <router-link
            :to="{ name: 'ExamWrong', params: { id: item.answer_id } }"
            target="_blank"
            class="uc-btn blue-plain"
            hover-class="none"
            v-if="(item.config & 8) == 8"
            >查看错题</router-link
          >
          <router-link
            :to="{ name: 'ExamRecord', params: { id: item.answer_id } }"
            target="_blank"
            class="uc-btn blue-plain"
            hover-class="none"
            v-if="(item.config & 1) == 1"
            >查看答案</router-link
          >
          <router-link
            :to="{ name: 'ExamRanking', params: { id: item.id } }"
            target="_blank"
            class="uc-btn blue-plain"
            hover-class="none"
            v-if="(item.config & 4) == 4"
            >查看排名</router-link
          >
        </div>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'StudyExam',
  data() {
    return {
      tabList: [
        { name: '全部', status: -1 },
        { name: '未答', status: 0 },
        { name: '已答', status: 1 },
        { name: '已过期', status: 2 },
      ],
      query: {
        status: -1,
        pageIndex: 1,
        pageSize: 6,
        keyword: undefined,
      },
      list: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getPapers();
    },
    async getPapers() {
      const response = await this.$api.exam.getPapers(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
    // 跳转
    handleExamClick(item) {
      switch (item.paper_status) {
        case 0:
          this.$message({ message: '考试未开始' });
          break;
        case 1:
          // 可考次数不限 或 可考次数大于已考次数 才可以进入考试
          if (item.allow_times === 0 || item.allow_times > item.answer_times) {
            this.$confirm(`确定要参加【${item.name}】考试吗？`, '提示', {
              type: 'info',
            }).then(() => {
              window.open(`/exam/answer/${item.id}`, 'ExamAnswer');
            });
          } else {
            this.$message({ message: '考试次数超出限制' });
          }
          break;
        case 2:
          this.$message({ message: '考试已结束' });
          break;
      }
    },
  },
};
</script>
